import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseDataResponse } from './models/base.model';
import { PagedRequest, PagedResponse } from './models/paged.model';

@Injectable({
  providedIn: 'root',
})
export abstract class PagedService {
  /**
   * Constructor
   */
  constructor(protected _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get paged data
   */
  protected getPaged<TData>(
    url: string,
    pagedRequest: PagedRequest | any
  ): Observable<BaseDataResponse<PagedResponse<TData>>> {
    let params: HttpParams = new HttpParams();

    Object.keys(pagedRequest).map((objKey) => {
      if (pagedRequest[objKey] != undefined && pagedRequest[objKey] != null) {
        if (typeof pagedRequest[objKey] == 'object') {
          pagedRequest[objKey].map((obj: number) => {
            params = params.append(`${objKey}[]`, obj);
          });
        } else {
          params = params.append(objKey, pagedRequest[objKey]);
        }
      }
    });

    return this._httpClient.get<BaseDataResponse<PagedResponse<TData>>>(url, {
      params,
    });
  }
}
